export const propertyTeam = ['$scope', function($scope) {
  $scope.activeVideo = 0
  $scope.toggleVideo = function(i) {
    $scope.activeVideo = i
  }
}]